import { P } from '../../theme/tokens';

export const CATEGORY_META = {
  leasing: { label: 'Leasing', color: P.info },
  maintenance: { label: 'Maintenance', color: P.warning },
  tenant: { label: 'Tenant', color: P.success },
  owner: { label: 'Owner', color: P.purple },
  general: { label: 'General', color: P.subtle }
};

export const CATEGORY_OPTIONS = Object.entries(CATEGORY_META).map(([value, m]) => ({ value, label: m.label }));

export { ROLE_META, tagColor } from '../../utils/tags';
